import Vue from "vue";
import Vuex from "vuex";

import { Token_EmailEncrypt } from "@/apis/api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isSerivceRouter: false,
    signinStatus: false,
    username: null,
    userPhoto: "",
    fromSite: {
      en: "",
      name: "",
      pageName: "",
      url: "",
      cmid: "",
    },
    userDevice: null,
    token: null,
  },
  mutations: {
    // 設定從哪個社群來的配置
    SetFromSiteCmidConfig(state, fromCmid) {
      if (fromCmid !== undefined) {
        state.fromSite.cmid = fromCmid;
        localStorage.setItem("fromCmid", fromCmid);
      }
    },
    // 設定從哪個子網站來的配置
    SetFromSiteConfig(state, fromSite) {
      // 如果沒有帶queryString 就抓localStorage裡的
      if (!fromSite) {
        fromSite = localStorage.getItem("fromSite");
        // localStorage沒有就塞社群
        if (!fromSite) {
          fromSite = "sms";
        }
      }

      if (fromSite.toLowerCase() === "sms") {
        state.fromSite.en = "sms";
        state.fromSite.name = "小芋頭社群";
        state.fromSite.pageName = "個人空間頁面";
        state.fromSite.url = process.env.VUE_APP_MAIN_SMS_BASE_URL;
        localStorage.setItem("fromSite", "SMS");
        return;
      }
      if (fromSite.toLowerCase() === "lt") {
        state.fromSite.en = "lt";
        state.fromSite.name = "小芋頭平台";
        state.fromSite.pageName = "小芋頭系統";
        state.fromSite.url = "https://www.king-fong.com/";
        localStorage.setItem("fromSite", "LT");
        return;
      }
      if (fromSite.toLowerCase() === "wt") {
        state.fromSite.en = "wt";
        state.fromSite.name = "小芋頭工作站";
        state.fromSite.pageName = "小芋頭工作站";
        state.fromSite.url = process.env.VUE_APP_MAIN_WT_BASE_URL;
        localStorage.setItem("fromSite", "WT");
        return;
      }
      if (fromSite.toLowerCase() === "aichat") {
        state.fromSite.en = "aichat";
        state.fromSite.name = "免費AI勞動法務諮詢";
        state.fromSite.pageName = "免費AI勞動法務諮詢";
        state.fromSite.url = process.env.VUE_APP_MAIN_AICHAT_BASE_URL;
        localStorage.setItem("fromSite", "AICHAT");
        return;
      }
      //先一律回社群
      // state.fromSite.url = process.env.VUE_APP_MAIN_SMS_BASE_URL;
    },
    // 取得登入狀態
    GetEmailEncrypt(state) {
      Token_EmailEncrypt()
        .then((res) => {
          state.username = res.data;
          state.signinStatus = true;
          console.log(res.data);
        })
        .catch(() => {
          state.username = null;
          state.signinStatus = false;
        });
    },
    // 設定使用者照片
    SetUserPhoto(state, url) {
      state.userPhoto = url;
    },
    GetUserDevice(state) {
      var u = navigator.userAgent;
      var ua = navigator.userAgent.toLowerCase();

      state.userDevice = {
        //偵測移動端瀏覽器版本信息
        trident: u.indexOf("Trident") > -1, //IE 核心
        presto: u.indexOf("Presto") > -1, //opera 核心
        webKit: u.indexOf("AppleWebKit") > -1, //Apple, google 核心
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //Firefox 核心
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //行動裝置
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android或uc瀏覽器
        iPhone: u.indexOf("iPhone") > -1, //是否為iPhone或者QQHD瀏覽器
        iPad: u.indexOf("iPad") > -1, //是否iPad
        webApp: u.indexOf("Safari") == -1, //是否web應用程式
        iosv: u.substr(u.indexOf("iPhone OS") + 9, 3), //ios版本
        weixin: ua.match(/MicroMessenger/i) == "micromessenger", //微信瀏覽器
        fbapp: u.indexOf("FBAV") > -1, //Facebook App內瀏覽器
        line: u.indexOf("Line") > -1, //Line內瀏覽器
      };
    },
  },
  actions: {
    SetFromSiteCmidConfig({ commit }) {
      commit("SetFromSiteCmidConfig");
    },
    SetFromSiteConfig({ commit }) {
      commit("SetFromSiteConfig");
    },
    GetEmailEncrypt({ commit }) {
      commit("GetEmailEncrypt");
    },
    GetUserDevice({ commit }) {
      commit("GetUserDevice");
    },
    SetUserPhoto({ commit }) {
      commit("SetUserPhoto");
    },
  },
  modules: {},
});
